import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: { features: { name: string }[] };
  features: { name: string }[];
}

export default function Form4(props: Props) {
  const { handleSubmit, register } = useForm({
    defaultValues: replaceDefaultValues(
      {
        features: [],
      },
      {
        features: props.defaultValues?.features?.map((el) => el.name),
      }
    ),
  });

  const handleFormSubmit = (data: any) => {
    data.features = data.features?.map((el: string) => ({ name: el }));
    props.onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <h1>Características de tu propiedad</h1>

      <FormElement
        name="features"
        label="Selecciona"
        errorAtTop
        inputRef={register}
        elementType="checkbox"
        elements={props.features.map((el) => ({
          name: el.name,
          value: el.name,
        }))}
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
